import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { UtilityHelper } from '@classes/utility-helper';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-install-banner',
    templateUrl: './install-banner.component.html',
    styleUrls: ['./install-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstallBannerComponent {
    isNative = Capacitor.isNativePlatform();
    url = UtilityHelper.isIOS() ? environment.iosUrl : environment.androidUrl;
    hide = signal(false);

    onClose(): void {
        this.hide.set(true);
    }
}
